<script setup>
import { ref } from 'vue';
import { mapGetters } from 'vuex';
import EventItem from './EventItem.vue';
import CalendarItem from './CalendarItem.vue';

</script>

<template>
  <div class="groups-modern-container">
    <div class="groups-grid">
      <div 
        v-for="group in groups" 
        :key="group.id"
        class="group-card"
        :class="{
          'group-card--selected': group.id === activeGroup?.id,
          'group-card--today': group.time_remaining.rem_day == 0 && group.time_remaining.rem_hour <= setRemTime
        }"
        @click="toggleDetails(group.id)"
      >
        <div class="group-card__header">
          <div class="group-card__icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div class="group-card__status" v-if="group.time_remaining.rem_day == 0 && group.time_remaining.rem_hour <= setRemTime">
            <span class="status-badge status-badge--today">Ma</span>
          </div>
        </div>
        
        <div class="group-card__content">
          <h3 class="group-card__title">{{ group.name }}</h3>
          <div class="group-card__details">
            <div class="detail-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12,6 12,12 16,14"/>
              </svg>
              <span>{{ parseSchedule(group.schedule) }}</span>
            </div>
            <div class="detail-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              <span>{{ group.next_dates }}</span>
            </div>
          </div>
        </div>
        
        <div class="group-card__footer">
          <div class="group-card__arrow">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- Modern Details Section -->
    <div v-if="activeGroup" class="group-details">
      <div class="group-details__header">
        <div class="group-details__icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <div class="group-details__title">
          <h2>{{ activeGroup.name }}</h2>
          <p>Táncóra részletei</p>
        </div>
      </div>
      
      <div class="group-details__content">
        <div class="details-grid">
          <div class="detail-card">
            <div class="detail-card__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12,6 12,12 16,14"/>
              </svg>
            </div>
            <div class="detail-card__content">
              <h4>Időpont</h4>
              <p>{{ parseSchedule(activeGroup.schedule) }}</p>
            </div>
          </div>
          
          <div class="detail-card">
            <div class="detail-card__icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
            </div>
            <div class="detail-card__content">
              <h4>Dátum</h4>
              <p>{{ activeGroup.next_dates }}</p>
            </div>
          </div>
        </div>
        
        <div class="event-section">
          <h3>Alkalom információ</h3>
          <div class="event-content">
            <EventItem :eventDate="activeGroup.next_date_bu" :groupId="activeGroup.id" :remTime="activeGroup.time_remaining"/>
          </div>
          
          <div v-if="activeGroup.time_remaining.rem_day > 0 || (activeGroup.time_remaining.rem_day == 0 && activeGroup.time_remaining.rem_hour > 1)">
            <div v-if="loading" class="loading-state">
              <div class="loading-spinner"></div>
              <p>Töltés...</p>
            </div>
            <div v-if="!loading" class="event-actions">
              <div v-if="evnt_groups && evnt_groups.length > 0">
                <div v-if="!evnt_groups[0].status.Valid || (evnt_groups[0].status.Valid && evnt_groups[0].status.String !== '20' && evnt_groups[0].status.String !== '99')" 
                     class="btn btn-danger" @click="event_deleted(activeGroup.event_id)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3,6 5,6 21,6"/>
                    <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"/>
                  </svg>
                  Lemondás
                </div>
                <div v-else class="alert alert-warning">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                  <div>
                    <strong>A táncóra törölve lett</strong>
                    <p v-if="evnt_groups[0].notes.Valid">{{ evnt_groups[0].notes.String }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="alert alert-info">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 16v-4"/>
                  <path d="M12 8h.01"/>
                </svg>
                <p>Nincsenek események jelenleg.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Calendar Sidebar -->
    <div class="calendar-sidebar">
      <CalendarItem />
    </div>
  </div>

  <!-- Modern Popup for Event Deletion -->
  <div v-if="showDeletePopup" class="mdl-overlay">
    <div class="mdl">
      <div class="mdl__header">
        <h3>Táncóra lemondása</h3>
        <button class="mdl__close" @click="closeDeletePopup">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="mdl__body">
        <div class="form-group">
          <label for="deleteReason">A lemondás oka</label>
          <textarea 
            id="deleteReason"
            v-model="deleteReason" 
            class="form-control" 
            placeholder="Kérjük, adja meg a lemondás okát..."
            rows="4"
          ></textarea>
        </div>
      </div>
      <div class="mdl__footer">
        <button class="btn btn-secondary" @click="closeDeletePopup">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
          Mégsem
        </button>
        <button class="btn btn-danger" @click="confirmDelete">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3,6 5,6 21,6"/>
            <path d="M19,6v14a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6m3,0V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"/>
          </svg>
          Lemondás
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
export default {
  data() {
    return {
      groups: [],
      setRemTime: 22, // The set time to check if it's today or not.
      activeGroup: null, // Store the currently active group for the expanded div
      showChildPopup: false,
      showChildActionsPopup: false,
      showDeletePopup: false,
      selectedChild: null,
      deleteReason: '',
      eventIdToDel: -1,
      evnt_groups: [],
      loading: true,
      isAdmin: false,
      isTeacher: false
    };
  },
  methods: {
    getIsAdmin() {
      this.isAdmin = this.$isAdmin();
    },
    getIsTeacher() {
      this.isTeacher = this.$isTeacher();
    },
    getUserId() {
      return this.$getUserId();
    },
    // Toggle the visibility of the additional details for a group
    async toggleDetails(groupId) {
      const group = this.groups.find(g => g.id === groupId);
      if (group) {
        if (this.activeGroup && this.activeGroup.id === groupId) {
          this.activeGroup = null; // Close if it's already active
        } else {
          this.activeGroup = group;
        }
      }
      await this.getGroupEvents();

    },

    // Parsing schedule from JSON (supports a single object or an array of
    // weekly time slots, e.g. Monday 17:00 and Thursday 17:30).
    parseSchedule(schedule) {
      try {
        const daysOfWeek = ["", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"];
        let parsed = JSON.parse(schedule);
        if (!Array.isArray(parsed)) {
          parsed = [parsed];
        }
        return parsed
          .filter(s => s && s.day && s.time)
          .map(s => `${daysOfWeek[s.day]} ${s.time}`)
          .join(", ");
      } catch (e) {
        return "Invalid schedule data";
      }
    },

    // Show the delete popup when the event is deleted
    event_deleted(id) {
      this.showDeletePopup = true;
      this.eventIdToDel = id;
    },

    // Close the delete popup
    closeDeletePopup() {
      this.showDeletePopup = false;
    },

    async delEvent() {
      try {
          const payload = {
            event_id: this.eventIdToDel,
            notes:  this.deleteReason,
            homework  : '',
          };
          const response = await axios.post(this.$BACKEND_HOST + '/api/deleteevent', payload);  // Replace with your backend API URL
          if(response.data.message == "done") {
            this.showChildPopup = false;
            this.getGroupEvents();
          }
        } catch (error) {
          console.error('Error marking attendance:', error);
        }
    },

    // Confirm delete action
    confirmDelete() {
      this.delEvent();      
      this.closeDeletePopup();
    },

    // Fetching the group data
    async getGroupDates() {
      try {
        // First, fetch all groups with dates
        const response = await fetch(`${this.$BACKEND_HOST}/api/groupdates`);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        let allGroups = data.groups;

        // If user is a teacher, filter to only show their assigned groups
        if (this.isTeacher && !this.isAdmin) {
          const teacherId = this.getUserId();
          console.log(teacherId);
          if (!teacherId) {
            throw new Error('Teacher ID not found');
          }
          
          // Fetch teacher's assigned groups
          const teacherResponse = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/groups?teacher_id=${teacherId}`);
          console.log(teacherResponse)
          if (teacherResponse.ok) {
            const teacherData = await teacherResponse.json();
            const assignedGroupIds = teacherData.groups.map(g => g.id);
            
            // Filter groups to only show assigned ones
            allGroups = allGroups.filter(group => assignedGroupIds.includes(group.id));
          }
        }

        this.groups = allGroups;

        // Initialize extra info for each group
        this.groups.forEach(group => {
          let date = new Date(group.next_dates);
          group.next_date_bu = group.next_dates;
          group.next_dates = date.toISOString().split('T')[0].replace(/-/g, '. ');
          group.children = group.children || []; // Assuming there's a "children" array
        });
        const groupMap = {};
        this.groups.sort((a, b) => a.next_date_bu.localeCompare(b.next_date_bu));
        this.groups.forEach(group => {
          if (!groupMap[group.id]) {
            groupMap[group.id] = group;
          }
        });
        this.groups = Object.values(groupMap);
        this.loading = false;
      } catch (err) {
        this.error = err.message;
      }
    },
    async getGroupEvents() {
      try {
        if(this.activeGroup != null ){
          
        const response = await axios.post(this.$BACKEND_HOST + '/api/groupevent', {
          event_grp_id: this.activeGroup.id,
          set_date: this.activeGroup.next_date_bu
        });
        if (response.data.message === "done") {
          console.log(response.data)
         if(response.data.groups != null) {
            this.evnt_groups = response.data.groups;

          } else {
            this.evnt_groups[0] = {status: {Valid: false}}
          }

        }
        }
      } catch (error) {
        console.error('Error updating item:', error);
      }
    },
  },
  mounted() {
    this.getIsAdmin();
    this.getIsTeacher();
    this.getGroupDates();
  }
};
</script>

<style scoped>
/* Modern Groups Container */
.groups-modern-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  min-height: 100%;
  padding: 2rem;
}

/* Groups Grid */
.groups-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Group Card */
.group-card {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.group-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.group-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-blue);
}

.group-card:hover::before {
  transform: scaleX(1);
}

.group-card--selected {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: white;
  border-color: var(--primary-blue);
  box-shadow: var(--shadow-lg);
}

.group-card--selected::before {
  transform: scaleX(1);
  background: rgba(255, 255, 255, 0.3);
}

.group-card--today {
  background: linear-gradient(135deg, var(--success), #22c55e);
  color: white;
  border-color: var(--success);
}

.group-card--today::before {
  background: rgba(255, 255, 255, 0.3);
  transform: scaleX(1);
}

/* Group Card Header */
.group-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.group-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: var(--primary-blue);
  flex-shrink: 0;
}

.group-card--selected .group-card__icon,
.group-card--today .group-card__icon {
  background: rgba(255, 255, 255, 0.3);
  color: white;
}

.group-card__status {
  display: flex;
  align-items: center;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge--today {
  background: rgba(255, 255, 255, 0.3);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* Group Card Content */
.group-card__content {
  margin-bottom: 1rem;
}

.group-card__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: var(--color-heading);
}

.group-card--selected .group-card__title,
.group-card--today .group-card__title {
  color: white;
}

.group-card__details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: var(--color-text-muted);
}

.group-card--selected .detail-item,
.group-card--today .detail-item {
  color: rgba(255, 255, 255, 0.9);
}

.detail-item svg {
  flex-shrink: 0;
  color: var(--primary-blue);
}

.group-card--selected .detail-item svg,
.group-card--today .detail-item svg {
  color: white;
}

/* Group Card Footer */
.group-card__footer {
  display: flex;
  justify-content: flex-end;
}

.group-card__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--color-background-mute);
  border-radius: 50%;
  color: var(--primary-blue);
  transition: all 0.3s ease;
}

.group-card:hover .group-card__arrow {
  background: var(--primary-blue);
  color: white;
  transform: translateX(4px);
}

.group-card--selected .group-card__arrow,
.group-card--today .group-card__arrow {
  background: rgba(255, 255, 255, 0.3);
  color: white;
}

/* Group Details Section */
.group-details {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  margin-bottom: 2rem;
  overflow: hidden;
}

.group-details__header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.group-details__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 12px;
  color: white;
  flex-shrink: 0;
}

.group-details__title h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
}

.group-details__title p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
}

.group-details__content {
  padding: 2rem;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.detail-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: var(--color-background-mute);
  border-radius: 12px;
  border: 1px solid var(--color-border);
}

.detail-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}

.detail-card__content h4 {
  color: var(--color-heading);
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-card__content p {
  color: var(--color-text);
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

.event-section {
  border-top: 1px solid var(--color-border);
  padding-top: 2rem;
}

.event-section h3 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
}

.event-content {
  margin-bottom: 1.5rem;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-border);
  border-top: 3px solid var(--primary-blue);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state p {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  margin: 0;
}

.event-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Alert Styles */
.alert {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  border: 1px solid;
}

.alert-warning {
  background: rgba(245, 158, 11, 0.1);
  border-color: var(--warning);
  color: var(--warning);
}

.alert-info {
  background: rgba(59, 130, 246, 0.1);
  border-color: var(--info);
  color: var(--info);
}

.alert svg {
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.alert div {
  flex: 1;
}

.alert strong {
  display: block;
  margin-bottom: 0.25rem;
}

.alert p {
  margin: 0;
  font-size: 0.875rem;
}

/* Button styles moved to components.css */

/* Calendar Sidebar */
.calendar-sidebar {
  position: sticky;
  top: 2rem;
}

/* mdl Styles */
.mdl-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  backdrop-filter: blur(4px);
}

.mdl {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-border);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow: hidden;
}

.mdl__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.mdl__header h3 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.mdl__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
}

.mdl__close:hover {
  background: var(--error);
  color: white;
}

.mdl__body {
  padding: 2rem;
}

.form-group {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--color-heading);
}

.form-control {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: 8px;
  background: var(--white);
  color: var(--color-text);
  font-size: 1rem;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 100px;
}

.form-control:focus {
  outline: none;
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.mdl__footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-top: 1px solid var(--color-border);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .groups-modern-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .calendar-sidebar {
    position: static;
    order: -1;
  }
}

@media (max-width: 1024px) {
  .groups-modern-container {
    padding: 1.5rem;
  }
  
  .groups-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1.25rem;
  }
}

@media (max-width: 768px) {
  .groups-modern-container {
    padding: 1rem;
  }
  
  .groups-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .group-card {
    padding: 1.25rem;
  }
  
  .group-details__header {
    padding: 1.25rem 1.5rem;
  }
  
  .group-details__content {
    padding: 1.5rem;
  }
  
  .details-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .detail-card {
    padding: 1.25rem;
  }
  
  .mdl {
    width: 95%;
    margin: 1rem;
  }
  
  .mdl__header,
  .mdl__body,
  .mdl__footer {
    padding: 1.25rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .groups-modern-container {
    padding: 0.75rem;
  }
  
  .group-card {
    padding: 1rem;
  }
  
  .group-card__header {
    margin-bottom: 0.75rem;
  }
  
  .group-card__icon {
    width: 40px;
    height: 40px;
  }
  
  .group-card__title {
    font-size: 1.125rem;
  }
  
  .group-details__header {
    padding: 1rem 1.25rem;
  }
  
  .group-details__icon {
    width: 48px;
    height: 48px;
  }
  
  .group-details__title h2 {
    font-size: 1.25rem;
  }
  
  .group-details__content {
    padding: 1.25rem;
  }
  
  .detail-card {
    padding: 1rem;
  }
  
  .mdl {
    width: 98%;
    margin: 0.5rem;
  }
  
  .mdl__header,
  .mdl__body,
  .mdl__footer {
    padding: 1rem 1.25rem;
  }
  
  .mdl__footer {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
